const { connect } = require('react-redux');
const BrokerCustomWalletInterveners = require ('./brokerCustomWalletInterveners');
const brokerCustomWalletIntervenersActions = require('../../actions/brokerCustomWalletInterveners');

module.exports.BrokerCustomWalletInterveners = connect(
    state => ({
        immBrokerCustomWalletInterveners: state.brokerCustomWalletInterveners
    }),{
        cancelViewInterveners: brokerCustomWalletIntervenersActions.cancelViewInterveners,
    }
)(BrokerCustomWalletInterveners);
